import React, { useEffect, useState } from 'react';
import {
    Avatar,
    Box,
    Button,
    IconButton,
    Menu,
    MenuItem,
    Paper,
    Typography,
    styled
} from '@mui/material';
import ReusableComponent from '../../components/reusableComponents/reusableInputComponents';
import SearchInput from '../../components/reusableComponents/reusableSearchInput';
import { useHistory, useParams } from 'react-router-dom';
import GenerateColumns from '../../_helpers/reusablefunctions/GenerateColumns';
import ReusableMuiIcons from '../../_helpers/ReusableMuiIcons';
import Tablecomponent from '../../components/reusableComponents/Tablecomponent';
import useDebounce from "../../_helpers/reusablefunctions/useDebounce";
import fetchApplications from "../../_helpers/reusablefunctions/fetchApplication";
import ApiService from '../../_services/ApiService';
import { TableSkeletonRows } from '../../components/reusableComponents/SkeletonCard';
import RejectModal from './RejectModal';
import useSnackDispatcher from '../../_helpers/reusablefunctions/snackBarComponent';

const Application = () => {
    const history = useHistory()
    const [platform, setPlatform] = useState("All");
    const [niche, setNiche] = useState('All');
    const [nicheList, setNicheList] = useState([]);
    const [role, setRole] = useState('Influencer');
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const { offerId } = useParams();
    const [selectedRows, setSelectedRows] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const debouncedSearchTerm = useDebounce(searchTerm, 1000)
    const [status, setStatus] = useState('All');
    const [count, setCount] = useState();

    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [selectedRowForMenu, setSelectedRowForMenu] = useState(null);
    const [rejectModalOpen, setRejectModalOpen] = useState(false);
    const [rejectTargetIds, setRejectTargetIds] = useState([]);
    const { successSnack, errorSnack } = useSnackDispatcher();

    const StyledCheckbox = styled('input')(({ disabled }) => ({
        width: '25px',
        height: '15px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.4 : 1,
    }));

    const formatFollowers = (num) => {
        if (num === null || num === undefined) return "";
        if (num >= 1_000_000) return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "m";
        if (num >= 1_000) return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "k";
        return num.toString();
    };

    const navigateToApplicationView = (rowData) => {
        history.push(`/view-application/${offerId}/pitch?creator_id=${rowData.creator_id}&campaign_type=${rowData.campaign_type}&handle=${rowData.creator_handle_id}`);
    };

    const platformList = [
        { label: 'All', value: 'All' },
        { label: 'Instagram', value: 'Instagram' },
        { label: 'YouTube', value: 'YouTube' }
    ];

    const applicationList = [
        { label: 'All', value: 'All' },
        { label: 'Approved', value: 'Approved' },
        { label: 'Rejected', value: 'Rejected' },
        { label: 'Pending', value: 'Pending' },
        { label: 'Live', value: 'Live' },
        { label: 'Closed', value: 'Closed' },
    ]

    const handleMenuOpen = (event, row) => {
        setSelectedRowForMenu(row);
        setMenuAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
        setSelectedRowForMenu(null);
    };

    const handleViewEdit = () => {
        navigateToApplicationView(selectedRowForMenu);
        handleMenuClose();
    };

    useEffect(() => {
        const fetchNiches = async () => {
            try {
                const response = await ApiService.get("offers_eligible");
                console.debug(response?.data?.data)
                if (response?.data?.data) {
                    const formatted = response.data.data.map(item => ({
                        label: item.TypeName,
                        value: item.id
                    }));
                    setNicheList([{ label: "All", value: "All" }, ...formatted]);
                }
            } catch (error) {
                console.error("Error fetching niches:", error);
            }
        };

        fetchNiches();
    }, []);

    const handleApplicationStatusUpdate = async (status, Ids, rejection_reasons = '', other_message = '') => {
        const searchParams = `id=${Ids.join(",")}`;
        try {
            const payload = { status };

            if (status === "Rejected") {
                // payload.rejection_reasons = rejection_reasons;
                payload.rejection_reasons = Array.isArray(rejection_reasons) ? rejection_reasons : [rejection_reasons];
                payload.other_message = other_message;
            }

            const response = await ApiService.put(
                'update_submission',
                payload,
                searchParams
            );
            console.log(`Application ${status}:`, response);
            await getApplicationsData();
            handleMenuClose();
            if (status === "Rejected") {
                errorSnack(`Pitch${Ids.length > 1 ? "es are" : " is"} ${status}`);
            } else if (status === "Approved") {
                successSnack(`Pitch${Ids.length > 1 ? "s" : ""} ${status} successfully!`);
            } else {
                successSnack(
                    `Application${Ids.length > 1 ? "s" : ""} ${status} successfully!`
                );
            }
        } catch (error) {
            console.error(`Error updating status to ${status}:`, error);
            errorSnack("Failed to update status. Please try again.");
        }
    };


    const handleApprove = () => {
        if (selectedRowForMenu?.id) {
            handleApplicationStatusUpdate("Approved", [selectedRowForMenu.id]);
        }
    };

    const handleReject = () => {
        if (selectedRowForMenu?.id) {
            setRejectTargetIds([selectedRowForMenu.id]);
            setRejectModalOpen(true);
            handleMenuClose();
        }
    };
    const handleApproveSelected = () => {
        if (selectedRows.length > 0) {
            handleApplicationStatusUpdate("Approved", selectedRows);
        }
    };

    const handleRejectSelected = () => {
        if (selectedRows.length > 0) {
            setRejectTargetIds(selectedRows);
            setRejectModalOpen(true);
        }
    };

    const handleRowSelect = (row) => {
        setSelectedRows((prev) =>
            prev.includes(row.id)
                ? prev.filter((id) => id !== row.id)
                : [...prev, row.id]
        );
    };

    const columnConfig = [
        {
            field: "checkbox",
            headerName: "",
            type: "custom",
            minWidth: 60,
            renderComponent: ({ row }) => {
                const status = (row.status || "");
                const isDisabled = status === "Approved" || status === "Rejected";

                return (
                    <StyledCheckbox
                        type="checkbox"
                        checked={selectedRows.includes(row.id)}
                        onChange={() => handleRowSelect(row)}
                        disabled={isDisabled}
                    />
                );
            }
        },
        {
            field: "profile",
            headerName: "Profile",
            type: "custom",
            minWidth: 200,
            renderComponent: ({ row }) => {
                const isMainRow = row.isMainRow || !row.isChild;
                return (
                    <Box>
                        {isMainRow && (
                            <Box
                                display="flex"
                                alignItems="center"
                                gap={1}
                                onClick={() => navigateToApplicationView(row)}
                                sx={{ cursor: "pointer" }}
                            >
                                <Avatar
                                    src={row.creator_logo}
                                    alt={row.name}
                                    sx={{ width: 40, height: 40 }} />
                                <Box>
                                    <Typography fontWeight={600} fontSize="0.875rem">
                                        {row.name}
                                    </Typography>
                                    <Typography fontWeight={400} fontSize="14px">
                                        {row.creator_agency_id}
                                    </Typography>
                                </Box>
                            </Box>
                        )}
                        {row.creatorHandle && (
                            <Typography fontSize="14px" color="text.secondary" ml={isMainRow ? 6 : 6}>
                                {row.creatorHandle}
                            </Typography>
                        )}
                    </Box>
                );
            }
        },
        {
            field: "applied",
            headerName: "Applied",
            type: "text",
            minWidth: 120,
        },
        {
            field: "followers",
            // headerName: platform === 'YouTube' ? 'Subscribers' : 'Followers',
            headerName: platform === 'YouTube' ? 'Subscribers' : platform === 'Instagram' ? 'Followers' : platform === 'All' ? 'Followers/Subscribers' : 'Followers',
            type: "custom",
            minWidth: 120,
            renderComponent: ({ value, row }) => {
                let iconName;
                const type = row.creator_handler_type?.toLowerCase();
                if (type === 'instagram') {
                    iconName = 'insta'
                }
                else if (type === 'youtube') {
                    iconName = 'youtube';
                } else if (type === 'facebook') {
                    iconName = 'facebook';
                }

                return (
                    <Box display="flex" alignItems="center" gap={1}>
                        <ReusableMuiIcons name={iconName} sx={{ fontSize: 18 }} />
                        <Typography variant="body2">{formatFollowers(value)}</Typography>
                    </Box>
                );
            },
        },
        {
            field: "location",
            headerName: "Location",
            type: "text",
            minWidth: 120,
        },
        {
            field: 'status',
            headerName: "Application Status",
            type: 'chip',
            minWidth: 140,
        },
        {
            field: "shippingStatus",
            headerName: "Shipping Status",
            type: "chip",
            minWidth: 140,
        },
        {
            field: "deliverablesStatus",
            headerName: "Deliverables Status",
            type: "chip",
            minWidth: 160,
        },
        {
            field: "livePostStatus",
            headerName: "Live Post Status",
            type: "chip",
            minWidth: 140,
        },
        {
            field: "actionBtn",
            headerName: "",
            type: "custom",
            minWidth: 30,
            renderComponent: ({ row }) => (
                <IconButton size="small" sx={{ color: "#6b7280" }} onClick={(e) => handleMenuOpen(e, row)}>
                    <ReusableMuiIcons name={'menu'} fontSize="small" />
                </IconButton>
            ),
        },
    ];

    const columns = GenerateColumns(columnConfig);

    useEffect(() => {
        getApplicationsData();
    }, [offerId, debouncedSearchTerm, platform, status, niche, '', rowsPerPage, page]);

    const getApplicationsData = async () => {
        setLoading(true);
        const { list, count } = await fetchApplications(offerId, debouncedSearchTerm, platform, status, niche, '', rowsPerPage, page);
        console.debug("dataaa", list)
        setCount(count)
        setTableData(list);
        setLoading(false);
    };

    return (
        <Box padding={2}>
            <Paper sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2, mb: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <SearchInput
                        placeholder="Search Offers"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        sx={{ width: "50%" }}
                    />
                    <ReusableComponent
                        type="select"
                        label="Platform"
                        placeholder="Instagram"
                        value={platform}
                        onChange={(option) => setPlatform(option?.value || '')}
                        options={platformList}
                        sx={{ width: 200 }}
                        size="small"
                    />
                    <ReusableComponent
                        type="select"
                        label="Application Status"
                        placeholder="All"
                        value={status}
                        onChange={(option) => setStatus(option?.value || '')}
                        options={applicationList}
                        sx={{ width: 200 }}
                        size="small"
                    />

                    <ReusableComponent
                        type="select"
                        label="Niche"
                        placeholder="All Niches"
                        value={niche}
                        onChange={(option) => setNiche(option?.label || '')}
                        options={nicheList}
                        size="small"
                        sx={{ width: 200 }}
                    />


                    {/* Influencer */}
                    {/* <ReusableComponent
                    type="select"
                    label=""
                    placeholder="Influencer"
                    value={role}
                    onChange={setRole}
                    options={roleList}
                    sx={{ paddingTop: '20px' }}
                    size="small"
                /> */}
                </Box>
            </Paper>

            <Tablecomponent
                columns={columns}
                data={tableData}
                loader={loading}
                page={page}
                count={count}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                onRowsPerPageChange={(e) => {
                    setRowsPerPage(parseInt(e.target.value, 10));
                    setPage(0);
                }}
                rowsPerPageOptions={[10, 20, 30]}
                onPageChange={(e, newPage) => setPage(newPage)}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                onApproveSelected={handleApproveSelected}
                onRejectSelected={handleRejectSelected}
                message="No data"
                content="Try creating an offer first."
                groupBy="groupkey"
                groupExpandable={true}
                defaultExpanded={false}
                bulkActions={['approve', 'reject']}
                onRowClick={(row) => navigateToApplicationView(row)}
            />

            <Menu
                anchorEl={menuAnchorEl}
                open={Boolean(menuAnchorEl)}
                onClose={handleMenuClose}
            >
                <MenuItem onClick={handleViewEdit}>View</MenuItem>
                {selectedRowForMenu && !["Approved", "Rejected"].includes(selectedRowForMenu.status) && (
                    <>
                        <MenuItem onClick={handleApprove}>Approve</MenuItem>
                        <MenuItem onClick={handleReject}>Reject</MenuItem>
                    </>
                )}
            </Menu>

            <RejectModal
                open={rejectModalOpen}
                onClose={() => setRejectModalOpen(false)}
                onConfirm={(reason, otherMessage) => {
                    handleApplicationStatusUpdate("Rejected", rejectTargetIds, reason, otherMessage);
                    setRejectModalOpen(false);
                }}
            />
        </Box>
    );
};

export default Application;
